import { EntityValidationRules } from "services/validation/entityValidationRules";
import { observable } from "mobx";
import { Expose } from "class-transformer";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ResetPassword {
  /**
   * @example
   * marek.novak@example.ppas.cz
   */
  @observable
  email!: string;

  @observable
  @Expose({ name: "sap_notice" })
  sapNotice: string;

  static ValidationRules = {
    email: { required: true },
  };
}

const ResetPasswordValidationRules: EntityValidationRules<ResetPassword> = {
  email: { required: true, isEmail: true },
};
export { ResetPasswordValidationRules };
